import { ApiResponse } from "../../types/common";
import { Institute } from "../../types/Institute";
import { axiosInstance } from "./axios";


export const InstituteApi = {
    GetInstituteById: async (id: number): Promise<{ institute: Institute }> => {
        const response = await axiosInstance.get<ApiResponse<Institute>>(`/v1/Institutes/${id}`);
        if (!response.data.succeeded) {
            throw new Error(response.data.messages?.[0] || 'failed to fetch');
        }
        return { institute: response.data.data };
    },
    UpdateInstitute: async (institute: Institute): Promise<void> => {
        const response = await axiosInstance.post<ApiResponse<string>>("/v1/Institutes", institute,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        if (!response.data.succeeded) {
            throw new Error(response.data.messages?.[0] || 'failed to Update');
        }
    }
}